import { makeStyles, Theme, withStyles, createStyles } from '@material-ui/core/styles';
import { red, pink, orange } from '@material-ui/core/colors';
import { InputBase } from '@material-ui/core';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    title: {
      flexGrow: 1,
      margin: theme.spacing(1),
    },
    fixedHeight: {
      height: 240,
    },
    flex: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    margin: {
      margin: theme.spacing(1),
    },
    search: {
      //margin: theme.spacing(2),
      width: '50%',
    },
    box: {
      marginBottom: theme.spacing(2),
      width: '100%',
    },
    headerBtn: {
      boxShadow: 'none',
      textTransform: 'none',
      lineHeight: '36px',
      padding: `0 ${theme.spacing(3)}px`,
    },
    smallLabel: {
      fontSize: 14,
    },
    noBorder: {
      border: 'none',
    },
    select: {
      margin: theme.spacing(1),
      '& .MuiSelect-select:focus': {
        background: '#fff',
      },
      //width: '30%',
    },
    dataGrid: {
      width: '100%',
      '& .MuiDataGrid-root .MuiDataGrid-row.Mui-selected ': {},
      '& .MuiDataGrid-root .MuiDataGrid-row': {
        '&:hover': {
          backgroundColor: 'rgba(255, 80, 95, 0.04)',
        },
      },
      '& .row-background-error': {
        backgroundColor: red[50],
        '&:hover': {
          backgroundColor: red[100],
        },
      },
      '& .row-background-alert': {
        backgroundColor: pink[50],
        '&:hover': {
          backgroundColor: pink[100],
        },
      },
      '& .row-background-transaction': {
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: 'rgba(255, 80, 95, 0.04)',
        },
      },
      '& .cell-text-color-error': {
        color: pink[700],
      },
      '& .cell-text-color-alert': {
        color: orange[700],
      },
      '& .cell-text-color-transaction': {
        color: 'black',
        fontWeight: '500',
        textTransform: 'capitalize',
      },
      '& .MuiDataGrid-colCellTitle': {
        color: 'black',
        fontWeight: '700',
        textTransform: 'capitalize',
      },
    },
    checkbox: {
      padding: theme.spacing(0, 1.5, 0, 0),
    },

    mainHeading: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '20px',
      color: '#000000',
      width: '40%',
    },
    header: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '20px',
      lineHeight: '133.4%',
      color: '#000000',
      margin: '24px 0',
      background: '#F6F6F6',
      padding: '10px 16px',
      display: 'flex',
      justifyContent: 'space-between',
    },
    border: {
      border: '1px solid #E0E0E0',
    },
    cellTitle: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '14px',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    container: {
      backgroundColor: '#ffffff',
      boxShadow: theme.shadows[0],
      padding: 32,
      fontSize: 20,
    },
    cellHeader: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '15px',
      color: 'rgba(0, 0, 0, 0.87)',
    },
  }),
  {
    index: 1,
  }
);

export const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
    },
    input: {
      marginLeft: theme.spacing(1),
      width: theme.spacing(20),
      borderRadius: 4,
      position: 'relative',
      //background: theme.palette.action.hover,
      background: '#fff',
      fontSize: 14,
      padding: 16,
    },
  })
)(InputBase);
